import { useTranslation } from "react-i18next";
import { moodUiFor } from "../i18n/locales/mood-ui";

const stateColor = (state) =>
  state === "bullish" ? "hsl(var(--bullish))" : state === "bearish" ? "hsl(var(--bearish))" : "hsl(var(--neutral))";

export function MoodGauge({ score = 50, state = "neutral", label, sublabel }) {
  const { t, i18n } = useTranslation();
  const color = stateColor(state);
  const ui = moodUiFor(i18n.language);

  return (
    <div data-testid={`mood-gauge-${label || state}`} title={ui.historicalTrendHelp}>
      <div className="mb-2 flex items-center justify-between gap-3">
        <span className="text-sm font-medium text-foreground">{label}</span>
        <span
          className="text-xs font-semibold tracking-wider"
          style={{ color }}
          dir="auto"
        >
          {ui.historicalTrend}: {t(`common.${state}`)}
        </span>
      </div>
      <div className="relative h-2 w-full overflow-hidden rounded-full bg-muted">
        <div
          className="absolute inset-y-0 start-0 rounded-full transition-[width] duration-500"
          style={{ width: `${score}%`, backgroundColor: color }}
        />
      </div>
      <div className="mt-1.5 flex items-center justify-between">
        <span className="num text-xs text-muted-foreground">{score}/100</span>
        {sublabel && <span className="text-xs text-muted-foreground">{sublabel}</span>}
      </div>
    </div>
  );
}
